export default function($) {
  const tabGroups = document.querySelectorAll('.products-tabs');

  tabGroups.forEach(group => {
    const tabInputs = group.querySelectorAll('.tab-input');
    const tabLabels = group.querySelectorAll('.tab-label');
    const tabContents = group.querySelectorAll('.tab-content');

    if (tabLabels.length > 0) {
      tabLabels[0].classList.add('active');
      tabContents[0].style.display = 'block';
      tabContents[0].style.opacity = '1';
    }

    tabInputs.forEach((input, index) => {
      input.addEventListener('change', function() {
        tabLabels.forEach(label => label.classList.remove('active'));
        tabContents.forEach(content => {
          content.style.display = 'none';
          content.style.opacity = '0';
        });

        const activeLabel = group.querySelector(`label[for="${this.id}"]`);
        const activeContent = tabContents[index];

        if (activeLabel) {
          activeLabel.classList.add('active');
        }

        if (activeContent) {
          activeContent.style.display = 'block';
          setTimeout(() => {
            activeContent.style.opacity = '1';
          }, 10);
        }
      });
    });
  });
}
